const GetDynamicListNames = (formDef) => {

    let dynamicLists = [];

    for (const page of formDef.Pages) {
        for (const column of page.Columns) {
            for (const formGroup of column.FormGroups) {
                for (const field of formGroup.Fields) {
                    if (field.Dynamic) { 
                        dynamicLists.push({name: field.OptionsName, includeFixed: ! field.RemoveFixed, translate: field.TranslateOptions});
                     }
                }
            }
        }
    }

    return dynamicLists;
}

const AddDynamicListsIntoForm = (formDef, lists) => {

    let dynamicLists = "";

    for (const page of formDef.Pages) {
        for (const column of page.Columns) {
            for (const formGroup of column.FormGroups) {
                for (const field of formGroup.Fields) {
                    if (field.Dynamic) { 
                        if (field.ParentList === undefined || field.ParentList === "") {
                            const list = lists.filter(l => l.name.toLowerCase() === field.OptionsName.toLowerCase());
                            field.Options = list[0].options;
                        }
                     }
                }
            }
        }
    }

    return dynamicLists;
}

export default GetDynamicListNames;
export {AddDynamicListsIntoForm};